import React from "react";
import { makeStyles } from "@mui/styles";
import { Divider, Typography } from "@mui/material";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./index.scss";
import SelectFirefighterAlert from "../../pages/ProjectDetail/SelectFirefighterAlert";
import ReviewInvoiceAlert from "../../pages/ProjectDetail/ReviewInvoiceAlert";
import { JOB_STATUSES, JOB_TYPES } from "../../utils/constants";
import Questions from "./questions";

const useStyle = makeStyles((theme) => ({
  secondColumn: {
    display: "flex",
    flexDirection: "column",
    width: "60%",
    marginTop: "31px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginTop: "2.375rem",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: "2.375rem",
    },
  },
  carousel: {
    height: "100%",
    maxHeight: "20rem",
    objectFit: "cover",
  },
  container: {
    marginTop: "15px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "12px",
    border: "1px solid #E8E8E8",
  },
  rowContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "2rem",
  },
  carouselContainer: { marginTop: "47px", marginBottom: "47px" },
}));

const ProjectDetailSecondColumn = ({ project, type }) => {
  const classes = useStyle();
  const { review } = project;

  const isJob = type === JOB_TYPES.JOB || type === JOB_TYPES.FRANCHISE;

  return (
    <div className={classes.secondColumn}>
      {!isJob && project?.status === JOB_STATUSES.WAITING && (
        <SelectFirefighterAlert />
      )}

      {!isJob && project?.status === JOB_STATUSES.COMPLETED && !review && (
        <ReviewInvoiceAlert project={project} />
      )}

      <Carousel
        showArrows
        showStatus={false}
        showThumbs={false}
        className={classes.carouselContainer}
      >
        {isJob && project.images
          ? project.images?.map((image) => (
              <img
                alt={image.id}
                src={image.data}
                key={image.id}
                className={classes.carousel}
              />
            ))
          : !isJob &&
            project.images &&
            project.images.map((image, index) => (
              <img
                alt="Project"
                src={image.url}
                key={index}
                className={classes.carousel}
              />
            ))}
      </Carousel>
      <div className={classes.container}>
        <div className={classes.rowContainer}>
          <Typography variant="title4">Details</Typography>
          <Typography variant="subtitle2">Project Description</Typography>
          <Typography variant="h7">{project?.description}</Typography>
        </div>
        <Divider />
        {(project?.specialEquipment === "yes" ||
          project?.specialEquipment === "maybe") && (
          <>
            <div className={classes.rowContainer}>
              <Typography variant="subtitle2">Special Equipment</Typography>
              <Typography variant="h7">{project.equipmentDetails}</Typography>
            </div>
            {project.notes && <Divider />}
          </>
        )}
        {project.notes && (
          <div className={classes.rowContainer}>
            <Typography variant="subtitle2">Additional information</Typography>
            <Typography variant="h7">{project.notes}</Typography>
          </div>
        )}
      </div>
      {!isJob && (
        <div className={classes.container}>
          <div className={classes.rowContainer}>
            <Typography variant="title4">Questions</Typography>
            <Questions workId={project.id} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectDetailSecondColumn;
